import React from 'react';
import TopicPage from '../../../components/TopicPageNew';
import bg from '../../../assets/history2/History_of_Sci_&_Tech_-_Industrial_Innovations.png';

function HistoryPageIndustrialInnovations() {
  return (
    <TopicPage
      topicKey="Industrial Innovations"
      title="History: Industrial Innovations"
      backgroundImage={bg}
      startRoute="/History-Industrial-Innovations-Go"
      scrollLabels={[
        "Steam Power and Factories",
        "Mass Production Techniques",
        "Transportation Advances",
      ]}
      backRoute="/history-host"
      backLabel="← Return to topics"
      backButtonClassName="journey-button special"
      backButtonStyle={{ fontSize: '1.1rem', backgroundColor: '#553c0d' }}
    />
  );
}

export default HistoryPageIndustrialInnovations;
